import styled from "styled-components";
import { black, hoverBlue, mainGray } from "../../assets/ui/colors";
import { FormValidate, InputContainer } from "../Auth/Auth.style";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFormValidate = styled(FormValidate)`
  padding: 0;
  margin: 0;
  text-align: left;
`;

export const StyledInputContainer = styled(InputContainer)`
  margin-top: 28px;
  & .MuiInputBase-inputMultiline {
    height: 112px;
    overflow: auto;
    padding: 16px 12px;
  }
`;

export const StyledFilesUploader = styled.label`
    display: flex;
    text-transform: uppercase;
    color: ${black};
    cursor: pointer;
    padding: 20px;
    margin: 16px 0 40px 0;
    & svg {
        margin-right: 7px;
    }
    & input[type="file"] {
        display: none;
    }
`;

export const FilesItem = styled.div`
    display: flex;
    padding: 20px 0;
    border-bottom: 1px solid ${hoverBlue};
    max-width: 395px;
`;

export const PreviewFile = styled.div`
    width: 40px;
    height: 40px;
    min-width: 40px;
    background-image: ${props => `url(${props.url})`};
    background-size: cover;
    border-radius: 20px;
`;

export const FileDescription = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileOptions = styled.span`
    color: ${mainGray};
    margin-top: 4px;
`;

export const RemovedContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 0 10px 10px;
    margin-left: auto;
    cursor: pointer;
`;

export const StyledButtonContainer = styled.div`
  max-width: 395px;
  color: white;
  & .MuiButton-contained {
    background-color: ${hoverBlue};
    color: white;
    border-radius: 6px;
    :hover {
      color: ${black};
    }
  }
`;
